import {createSelector} from 'reselect'
import {showEditor} from "../workAssignmentsEditor/selectors"
import selectorsGenerator from '../hierarchyAssignmentsPanelTab/selectorsGenerator'

import {arrayToMap} from '../../../atUtils'
import {hasSubmitTTRight} from '../../../util/accessRightsUtils'

const getWorkAssignmentsPanelState = state => state.userManagement.workAssignmentsPanel
const hierarchyAssignmentsPanelTabSelectors = selectorsGenerator(getWorkAssignmentsPanelState)

export const getUserId = hierarchyAssignmentsPanelTabSelectors.getUserId

export const getTab = hierarchyAssignmentsPanelTabSelectors.getTab

export const getTaskIds = hierarchyAssignmentsPanelTabSelectors.getTaskIds

export const getProjectIds = hierarchyAssignmentsPanelTabSelectors.getProjectIds

export const getSearch = hierarchyAssignmentsPanelTabSelectors.getSearch

export const isSearchOpen = hierarchyAssignmentsPanelTabSelectors.isSearchOpen

export const loadedTabs = hierarchyAssignmentsPanelTabSelectors.getLoadedTabs

export const getCounters = hierarchyAssignmentsPanelTabSelectors.getCounters

export const getPanelUserFirstName = hierarchyAssignmentsPanelTabSelectors.getPanelUserFirstName

export const getPanelUserFML = hierarchyAssignmentsPanelTabSelectors.getPanelUserFML

export const selectTaskEntities = hierarchyAssignmentsPanelTabSelectors.selectTaskWaEntities

export const selectProjectEntities = hierarchyAssignmentsPanelTabSelectors.selectProjectWaEntities

export const selectCustomerEntities = hierarchyAssignmentsPanelTabSelectors.selectCustomerWaEntities

export const isLoading = hierarchyAssignmentsPanelTabSelectors.isLoading

export const isLoaded = hierarchyAssignmentsPanelTabSelectors.isLoaded

export const isShowArchivedEntities = hierarchyAssignmentsPanelTabSelectors.isShowArchivedEntities

export const isShown = createSelector(
    getUserId,
    (userId) => userId !== null
)

export const isNeedToLoadData = createSelector(
    isShown,
    isLoaded,
    getTab,
    loadedTabs,
    showEditor,
    (show, loaded, tab, loadedTabs, showEditor) => show === true && (loaded === false || loadedTabs[tab] === false) && showEditor === false
)

export const getEntirelyAssignedTasksCounter = createSelector(
    getTaskIds,
    getCounters,
    (ids, counters) => {
        return counters.tasks.curValue - ids.length
    }
)

export const getEntirelyAssignedProjectCounter = createSelector(
    getProjectIds,
    getCounters,
    (ids, counters) => {
        return counters.projects.curValue - ids.length
    }
)

export const isShowCopyContent = (state) => getWorkAssignmentsPanelState(state).showCopyContent

export const isShowAllAssignScopeContent = (state) => getAssignAllScopeContent(state).show

export const getCopyContentState = (state) => getWorkAssignmentsPanelState(state).copyContent

export const isNoCptAssignedToUserAtAll = (state) => getWorkAssignmentsPanelState(state).noCptAssignedToUserAtAll

export const getAssignAllScopeContent = (state) => getWorkAssignmentsPanelState(state).assignAllScopeContent

export const getCopyUserId = (state) => getCopyContentState(state).userId

export const isCopyLoading = (state) => getCopyContentState(state).loading

export const isAssignAllScopeContentLoading = (state) => getAssignAllScopeContent(state).loading

export const getCopyUserCounters = (state) => getCopyContentState(state).counters

export const isCopyUserAllScope = (state) => getCopyContentState(state).isAllScopeToCopyUserFrom

export const getCopySelectedOption = (state) => getCopyContentState(state).selectedOption

export const isViewerHasEntireScope = (state) => getCopyContentState(state).viewerHasEntireScope

const _getSelectorsUsers = createSelector(
    getCopyContentState,
    copyContent => copyContent.usersForSelector
)

export const getSelectorsUsers = createSelector(
    _getSelectorsUsers,
    getUserId,
    (usersForSelector, userToId) => usersForSelector.filter(user => user.id !== userToId && hasSubmitTTRight(user))
)

export const getCopyUserFrom = createSelector(
    getCopyUserId,
    getSelectorsUsers,
    (id, users) => {
        const usersMap = arrayToMap(users)
        return usersMap[id]
    }
)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/selectors.js